const BackNavIcon = (props: any) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.8" cx="16" cy="16" r="16" fill="#9695C7" />
      <path
        d="M18.9998 23.9201L12.4798 17.4001C11.7098 16.6301 11.7098 15.3701 12.4798 14.6001L18.9998 8.08008"
        stroke="white"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export { BackNavIcon };
